import { createSelector } from 'reselect'

const resumenPedidosSelector = state => state.pedidosReducer.getIn(["resumen"])
export const resumenSelector = createSelector(
  resumenPedidosSelector, (dataField) => {      
      return dataField
    }
  )

  
const carritosAbandonadosSelector_raw = state => state.pedidosReducer.getIn(["carritosAbandonados"])
export const carritosAbandonadosSelector = createSelector(
  carritosAbandonadosSelector_raw, (dataField) => {      
      return dataField.toJS?dataField.toJS():dataField;
    }
  )

  
const carritosResult = state => state.pedidosReducer.getIn(["resultBorrarCarrito"])
export const carritosResultSelector = createSelector(
  carritosResult, (dataField) => {      
      return dataField.toJS?dataField.toJS():dataField;
    }
  )

const dataSelector = state => state.pedidosReducer.getIn(["data"]).toJS()
export const pedidoReducerDataSelector = createSelector(
  dataSelector, (dataField) => {      
      
    // armo m objeto de pedido
    let myPedidos = undefined
    if(dataField.pedidos)
    {
      myPedidos = {}

      // datos de paginación
      myPedidos.totalPages = dataField.pedidos.totalPages
      myPedidos.currentPage = dataField.pedidos.currentPage
      myPedidos.totalObjects = dataField.pedidos.totalObjects

      // armo la lista de pedidos de la página
      myPedidos.result = []
      for(var i=0; i<dataField.pedidos.result.length; i++)
      {
        let item = dataField.pedidos.result[i]

        // armo el item de pedido
        let p = {}
        p.id = item.idPedido
        p.razonSocial = item.razonSocial
        p.nombreFantasia = item.nombreFantasia
        p.apellidoNombre = item.apellidoNombre
        p.precioFinal = item.precioFinal
        p.fechaRegistro = item.fecha
        p.usuarioRegistro = item.usuario
        p.telefono = item.telefono
        p.estadoPedido = item.estadoPedido
        p.poseeLogo = item.poseeLogo
        p.imagen = item.imagen
        p.idFormaPagoOnline = item.idFormaPagoOnline
        p.descripcionFormaPago = item.descripcionFormaPago
        p.idOperaciónMP = item.idOperaciónMP
        p.pagado = item.pagado
        p.totalAPagar = item.totalAPagar
        p.totalConfirmado = item.totalConfirmado
        p.correo = item.correo
        p.dni = item.dni
        p.direccion = item.direccion
        p.localidad = item.localidad
        p.turno = item.turno
        p.faltaGeoreferenciar = item.faltaGeoreferenciar
        p.tipoFacturacion = item.tipoFacturacion
        p.fraudePotencial=item.fraudePotencial

        myPedidos.result.push(p)
      }
    }

    return {
      pedidos: myPedidos,
      estadosPedido: dataField.estadosPedido,
      formasEntrega: dataField.formasEntrega
    }
  }
)

const calendarioSelector = state => state.pedidosReducer.getIn(["calendarioPedidos"])
export const calendarioPedidosReducerDataSelector = createSelector(
  calendarioSelector, (dataField) => {      
    return dataField;
  }
)


export const pedidoDetalleSelector = createSelector(
  dataSelector, (dataField) => {
    let pedido = dataField.pedidoDetail
    
    if (!pedido) return pedido; //null or undefined
    if (!pedido.pedidoDetalles) return undefined;

    pedido.pedidoDetalles = pedido.pedidoDetalles.map(
      (pd)=>({...pd, imagen: pd.imagen, imagenColor: pd.imagenColor})
    )
      
    /*Obtencion de array de rubros */
    //Nombres de rubros ordenados
    let nombresRubros =[...new Set(pedido.pedidoDetalles.map(x=>{return x.rubro}).sort((x,y)=>{ return x> y}))]; 
    
    //Todos los rubros con sus subrubros repetidos
    let rubrosOrdenados = pedido.pedidoDetalles.map((x=>{return{rubro:x.rubro, subrubro:x.subrubro}}))
    let rubros = [];
    
    //Itero los nombres de los rubros y armo un objeto de rubros con sus respectivos subrubros sin repetir
    nombresRubros.forEach(nombre=>{

      //Todos los subrubros del rubro
      let subrubros = rubrosOrdenados.filter(x=>x.rubro === nombre).map(x=>x.subrubro);
      subrubros =subrubros.sort((x,y)=>{ return x> y});

      //Agrego al objeto de rubros
      rubros.push({rubro: nombre, sub: [...new Set(subrubros)] })
    })

    pedido.rubros = rubros;

   

    // pedido.rubros = pedido.pedidoDetalles
    // .sort((x,y)=>{ return x.rubro > y.rubro }) //ordeno por rubro
    // .map((x=>x.rubro)) //selecciono el dato que deseo
    // .filter( (i,pos,arr)=>( i!==arr[pos+1])) //filtro los repetidos
    // .map( x =>( { rubro: x , sub: pedido.pedidoDetalles //añado los subrubros
    //   .filter(y=>(y.rubro===x)) //filtro los subrubros de cada rubro
    //   .sort((y,z)=>{ return y.subrubro > z.subrubro }) //los ordeno
    //   .map(y=>(y.subrubro))//selecciono  el dato en si
    //   .filter((i,pos,arr)=>( i!==arr[pos+1])) //filtro repetidos
    //   })
    // )
    
    return pedido 
  }
)

const sugerenciasReducerSelector = state => state.pedidosReducer.getIn(["data"]).toJS()
export const sugerenciasSelector = createSelector(
  sugerenciasReducerSelector, (dataField) => {  
    return dataField.sugerencias
  }
)

const filtroPedidosReducerSelector = state => state.pedidosReducer.getIn(["filtroPedidos"])
export const filtroPedidosSelector = createSelector(
  filtroPedidosReducerSelector, (dataField) => {  
    return dataField
  }
)

const ultimoItemActualizadoReducerSelector = state => state.pedidosReducer.getIn(["ultimaActualizacion"])
export const ultimoItemActualizadoSelector = createSelector(
  ultimoItemActualizadoReducerSelector, (dataField) => {  
    return dataField
  }
)

const motivosEliminacionReducerSelector = state => state.pedidosReducer.getIn(["data"]).toJS()
export const motivosEliminacionSelector = createSelector(
  motivosEliminacionReducerSelector, (dataField) => {  
    return dataField.motivosEliminacion
  }
)